export const WrittenFormat = (str, maxLength = 45) => {
  if (!str) return '';

  const formatted = str
    .toLowerCase()
    .trim()
    .split(/\s+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  return formatted.length > maxLength
    ? formatted.slice(0, maxLength).trim() + '...'
    : formatted;
};
